
.createNewBoxButtonContainer {
  min-height: 2.5rem;
  border-radius: 0.75rem;
}

